(() => {
  function initSlider(slider) {
    if (slider.dataset.initialized === 'true') return;
    const maxCents = Number(slider.dataset.priceMax);
    const uiMaxCents = Number(slider.dataset.priceUiMax);
    const minHandle = slider.querySelector('.ml-price-slider__handle--min');
    const maxHandle = slider.querySelector('.ml-price-slider__handle--max');
    const nativeInputs = slider.querySelectorAll('.ml-price-slider__native input');
    if (!minHandle || !maxHandle || nativeInputs.length !== 2 || !Number.isFinite(maxCents) || !Number.isFinite(uiMaxCents)) return;
    slider.dataset.initialized = 'true';
    nativeInputs.forEach((input) => {
      input.tabIndex = -1;
      input.setAttribute('aria-hidden', 'true');
    });

    let formatter;
    try {
      formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: slider.dataset.currency,
        minimumFractionDigits: 0, maximumFractionDigits: 0
      });
    } catch (_) {
      formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        minimumFractionDigits: 0, maximumFractionDigits: 0
      });
    }

    function render() {
      const min = Number(minHandle.value);
      const max = Number(maxHandle.value);
      if (min === max && !slider.dataset.topHandle) slider.dataset.topHandle = min === uiMaxCents ? 'min' : 'max';
      if (min !== max) delete slider.dataset.topHandle;
      slider.classList.toggle('is-tight', uiMaxCents > 0 && (max - min) / uiMaxCents < 0.09);
      slider.querySelector('.ml-price-slider__min-value').textContent = formatter.format(min / 100);
      slider.querySelector('.ml-price-slider__max-value').textContent = formatter.format(max / 100);
      minHandle.setAttribute('aria-valuetext', formatter.format(min / 100));
      maxHandle.setAttribute('aria-valuetext', formatter.format(max / 100));
      slider.style.setProperty('--range-start', `${uiMaxCents ? min / uiMaxCents * 100 : 0}%`);
      slider.style.setProperty('--range-end', `${uiMaxCents ? max / uiMaxCents * 100 : 100}%`);
    }

    function update(handle, commit) {
      if (handle === minHandle && Number(minHandle.value) > Number(maxHandle.value)) {
        minHandle.value = maxHandle.value;
      }
      if (handle === maxHandle && Number(maxHandle.value) < Number(minHandle.value)) {
        maxHandle.value = minHandle.value;
      }
      const min = Number(minHandle.value);
      const max = Number(maxHandle.value);
      if (min === max) slider.dataset.topHandle = handle === minHandle ? 'max' : 'min';
      render();
      if (!commit) return;

      const minAmount = min === 0 ? '' : (Math.min(min, maxCents) / 100).toFixed(2);
      const maxAmount = max === uiMaxCents ? '' : (max / 100).toFixed(2);
      if (handle === minHandle) {
        nativeInputs[0].value = minAmount;
        if (nativeInputs[1].value !== '' && Number(minAmount) > Number(nativeInputs[1].value)) {
          nativeInputs[1].value = maxAmount;
        }
      } else {
        nativeInputs[1].value = maxAmount;
        if (nativeInputs[0].value !== '' && maxAmount !== '' && Number(maxAmount) < Number(nativeInputs[0].value)) {
          nativeInputs[0].value = minAmount;
        }
      }
      nativeInputs[handle === minHandle ? 0 : 1].dispatchEvent(new Event('input', { bubbles: true }));
    }

    [minHandle, maxHandle].forEach((handle) => {
      handle.addEventListener('input', (event) => {
        event.stopPropagation();
        update(handle, false);
      });
      handle.addEventListener('change', () => update(handle, true));
    });
    render();
  }

  window.MooselogPriceSlider = {
    initAll() {
      document.querySelectorAll('.ml-discovery .ml-price-slider').forEach(initSlider);
    }
  };
  window.MooselogPriceSlider.initAll();
})();
